import { render, staticRenderFns } from "./ResourcesSummary.vue?vue&type=template&id=ba15c758&scoped=true&"
import script from "./ResourcesSummary.vue?vue&type=script&lang=js&"
export * from "./ResourcesSummary.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesSummary.vue?vue&type=style&index=0&id=ba15c758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba15c758",
  null
  
)

export default component.exports